module.exports = __webpack_public_path__ + "img/rikkert_ten_klooster.cdec160a.jpg";